<img class="logo" [src]="logoPath" alt="logo" />

<div class="config-error">
  <div class="icon-container mb-5">
    <div class="outer-circle">
      <div class="inner-circle">
        <i class="uil uil-exclamation-triangle"></i>
      </div>
    </div>
  </div>

  <h3 class="mb-3">We couldn't load your provider details</h3>

  <p class="body-xl-regular mb-4">
    Something went wrong while loading your account. Please try again.
  </p>

  @if (authService.currentUser()) {
    <sliqpay-ui-button testId="retry-btn" (pressed)="onRetry()">Retry</sliqpay-ui-button>
  }
</div>
